var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0222ba",
    d: "M19.14 12.94a7.074 7.074 0 0 0 .06-.94 5.777 5.777 0 0 0-.07-.94l2.03-1.58a.491.491 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96a7.064 7.064 0 0 0-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84a.474.474 0 0 0-.47.41l-.36 2.54a7.22 7.22 0 0 0-1.62.94l-2.39-.96a.477.477 0 0 0-.59.22L2.74 8.87a.455.455 0 0 0 .12.61l2.03 1.58a5.563 5.563 0 0 0-.02 1.88l-2.03 1.58a.491.491 0 0 0-.12.61l1.92 3.32a.488.488 0 0 0 .59.22l2.39-.96a7.064 7.064 0 0 0 1.62.94l.36 2.54a.492.492 0 0 0 .48.41h3.84a.466.466 0 0 0 .47-.41l.36-2.54a6.859 6.859 0 0 0 1.62-.94l2.39.96a.477.477 0 0 0 .59-.22l1.92-3.32a.463.463 0 0 0-.12-.61zM12 15.6a3.6 3.6 0 1 1 3.6-3.6 3.611 3.611 0 0 1-3.6 3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.b37375200c5ebaae2897e1fb658c2ffc.svg";
export { ForwardRef as ReactComponent };